import { useState } from 'react'
import { useActivePhoto } from '@context/ActivePhotoContext'
import Lightbox from '@components/display/photos/LightboxDynamic'
import Controls from '@components/display/photos/LightboxControlsDynamic'
import { touchHandlers, touchCallback } from './touchEvents'
import AdvancedImage from '@components/image/WithFallback'
import ImageWrapper from '@components/image/WrapperAlt'
import BlackBox from '@components/display/video/BlackBox'
import Video from '@components/display/video/Video'
import fullPhoto from '@utils/links/fullPhoto'
import withBreakpoints from '@hoc/withBreakpoints'

const MainPhoto = ({ alt, breakpoints, fallback, offer }) => {
    const [showLightbox, setShowLightbox] = useState(false)
    const pid = offer?.tracking?.pid
    const photos = offer?.photos
    const video = offer?.video_link

    if (!pid) return null

    const onMobile = breakpoints.mobile

    const currentActivePhoto = useActivePhoto()
    const controlMin = video ? -1 : 0
    const controlMax = photos?.length ? photos.length - 1 : controlMin
    const controls = <Controls max={controlMax} min={controlMin} />

    const toggleLightbox = !onMobile && photos && (() => setShowLightbox(!showLightbox))
    const touchHandlerProps = touchHandlers(touchCallback, toggleLightbox)
    return <>
        { showLightbox &&
                <Lightbox
                    photos={photos}
                    pid={pid}
                    toggle={toggleLightbox}
                    video={video} /> }
        {
            currentActivePhoto === -1
                ? <BlackBox>
                    <Video offer={offer} />
                    {controls}
                  </BlackBox>

                : (
                    <ImageWrapper>
                        <AdvancedImage {...touchHandlerProps}
                            alt={alt || ''}
                            draggable={false}
                            fallback={fallback}
                            layout="fill"
                            objectFit="cover"
                            src={fullPhoto(pid, currentActivePhoto)} />
                        {controls}
                    </ImageWrapper>
                )
        }
    </>
}

export default withBreakpoints({ mobile: 1024 })(MainPhoto)